import React from 'react'
import '../../styles/SwiftBankingStyles/cranetwo.css'
import craneOne from './../../resources/SwiftBankingResources/crane-2.svg'
import hookOne from './../../resources/SwiftBankingResources/hook-1.svg'
import hookTwoTwo from './../../resources/SwiftBankingResources/hook-2-2.svg'
import kronnCard from './../../resources/SwiftBankingResources/kronn-card.svg'

import building from './../../resources/SwiftBankingResources/crane-2-building.svg'

import platLeft from './../../resources/HomePageResources/platform-down-left.svg'
import platRight from './../../resources/HomePageResources/platform-down-right.svg'


export default class CraneTwo extends React.Component{
    render(){
        return(
            <section className="craneone__container">

                <div className="sb-c2__box">
                    <img className="sb-c2__hook" src={hookOne} />
                    <div className="sb__box">
                        <div className="sb__box-title">Open<br/>Anywhere</div>
                        <div className='text sb__box-text'>
                            Check your eligibility <br/>
                            online and receive your <br/>
                            ready to use kronn <br/>
                            debit card shortly after!
                        </div>
                        {/*<div className="sb__read-more">Read more</div>*/}
                    </div>
                    <div className="sb__platform">
                        <img className="sb__plat-left" src={platLeft} />
                        <div className="sb__plat__middle"/>
                        <img className="sb__plat-right" src={platRight} />
                    </div>
                </div>

                <div className="sb__c2">
                    <img className="sb-c2__img" src={craneOne}/>
                    <img className="sb-c2__building__img" src={building}/>
                    <img className="sb-hook-2-2__img" src={hookTwoTwo}/>
                    <img src={kronnCard} className="sb-c2__card" />
                    <div className="sb-c2__invis" />
                    <div className="sb-c2__platform">
                        <img className="sb-c2__plat-left" src={platLeft} />
                        <div className="sb-c2__plat__middle"/>
                        <img className="sb-c2__plat-right" src={platRight} />
                    </div>
                </div>


            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SwiftBanking/CraneTwo.js